import { createReducer, on } from '@ngrx/store';
import { InstalledApplicationsApiActions } from './installed-applications.actions';
import { initialState, adapter } from './installed-applications.state';

export const installedApplicationsReducer = createReducer(
  initialState,
  on(InstalledApplicationsApiActions.installedApplicationsLoaded, (state, { installedApplications }) =>
    adapter.upsertMany(installedApplications, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectInstalledApplicationsIds = selectIds;

export const selectInstalledApplicationsEntities = selectEntities;

export const selectAllInstalledApplications = selectAll;
